import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { memberApi as API } from '../Apis';

export const UpdateMemberDocs: IDocs = {
  title: 'UpdateMember',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.updateMember',
};

const prepareCall = (stateRequestParameters: any) => {
  let documentList = {};
  if (
    stateRequestParameters?.document &&
    stateRequestParameters?.document?.value
  ) {
    documentList = {
      documentList: [
        {
          type: stateRequestParameters?.document?.type,
          number: stateRequestParameters?.document?.value,
        },
      ],
    };
  }

  let phoneList = {};
  if (
    stateRequestParameters?.cellPhone &&
    stateRequestParameters?.cellPhone?.number
  ) {
    phoneList = {
      phoneList: [
        {
          type: 'CELLULAR',
          internationalCode: stateRequestParameters?.cellPhone?.DDI,
          areaCode: stateRequestParameters?.cellPhone?.DDD,
          number: stateRequestParameters?.cellPhone?.number,
        },
      ],
    };
  }

  return API.call.put({
    ...documentList,
    ...phoneList,
    addressList: [
      {
        preferential: true,
        streetName: stateRequestParameters?.address?.streetName,
        streetNumber: stateRequestParameters?.address?.streetNumber,
        complement: stateRequestParameters?.address?.complement,
        zipCode: stateRequestParameters?.address?.zipCode,
        city: stateRequestParameters?.address?.city,
        state: stateRequestParameters?.address?.state,
        country: stateRequestParameters?.address?.country,
      },
    ],
    electronicAddressList: [
      {
        preferential: true,
        type: 'PERSONAL',
        address: stateRequestParameters.email,
      },
    ],
    allowMail: stateRequestParameters.allowMail,
    allowSMS: stateRequestParameters.allowSMS,
    allowPromoEmail: stateRequestParameters.allowPromoEmail,
    socialIdNumber: stateRequestParameters.socialIdNumber,
    socialIdProvider: stateRequestParameters.socialIdProvider,
    emailSocialNetwork: stateRequestParameters.emailSocialNetwork,
    geoCode: stateRequestParameters.geoCode,
    sendAccrualRdmEmail: stateRequestParameters.sendAccrualRdmEmail,
    deviceFingerprint: stateRequestParameters.deviceFingerprint,
    acceptTerms: stateRequestParameters.acceptTerms,
    contactType: stateRequestParameters.contactType,
  });
};

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const smilesCheckAccount = !infos?.errorService;
  const smilesErrorService = infos?.errorService || !smilesCheckAccount;

  return { smilesCheckAccount, smilesErrorService };
};

export const UpdateMemberMachine = GenericMachine(
  prepareCall,
  {
    docs: UpdateMemberDocs,
    definitions: API.definitions,
  },
  {
    handleErrorFlowFinalResponseFunction,
  },
);
